import { orderStore } from './store';

export const computeTotalLineItems = (): number => {
  return orderStore.order.lineItems.length > 0
    ? orderStore.order.lineItems
        .filter((v) => v.operationType !== 'Delete')
        .reduce((acc, item) => {
          let rate = item.rate;
          if (rate === '' || rate === '.' || rate === '-') {
            rate = '0';
          }
          return acc + Number(rate) * Number(item.quantity);
        }, 0)
    : 0;
};
